import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Caixa } from 'src/app/admihair/api/dto/caixa';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { LazyLoadEvent } from 'primeng/api';
import { CaixaService } from 'src/app/admihair/service/caixa.service';
import { Constantes } from 'src/app/admihair/util/constantes';
import { Table } from 'primeng/table';
import { CaixaGerenciar } from 'src/app/admihair/api/dto/caixa-gerenciar';

@Component({
  selector: 'app-caixa-gerenciar-listar',
  templateUrl: './caixa-gerenciar-listar.component.html',
  styleUrls: ['./caixa-gerenciar-listar.component.scss']
})
export class CaixaGerenciarListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  loading: boolean = true;
  listaCaixas: CaixaGerenciar[] = [];
  itensPaginados?: Paginador<CaixaGerenciar>;
  numeroPagina: number = 0;
  ordenacao?: string = 'dataCaixa,DESC';
  inputBusca: string = '';

  listaStatus: string[] = ['TODOS', 'ABERTO', 'FECHADO', 'REABERTO'];
  statusSelecionado: string = 'TODOS';
  dataCaixa?: Date;

  dataAtual: Date = new Date();
  dataSelecionadaNovoCaixa?: Date; 

  exibirDialogAbrirCaixa: boolean = false;
  loadingSpinnerAbrirCaixa: boolean = false;

  constructor(private caixaService: CaixaService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute) {
      super(erroService, storageService, router, activatedRoute)
     }

  ngOnInit(): void {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_GERENCIAR_CAIXA');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_GERENCIAR_CAIXA');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_GERENCIAR_CAIXA');
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_GERENCIAR_CAIXA');
  }

  listarCaixas() {
    this.loading = true;
    this.caixaService.listarPorEmpresaPaginado(this.getEmpresa().id, this.statusSelecionado, 
    this.numeroPagina, this.dataCaixa, Constantes.QTD_ITENS_10_POR_PAGINA, this.ordenacao).subscribe({
      next: (data: Paginador<CaixaGerenciar>) => {
        this.listaCaixas = data.content;
        this.itensPaginados = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })

  }


  onLazyLoad(event: LazyLoadEvent) {
    if(event.first !== undefined && event.rows !== undefined) {
      if (event.first === 0 && event.rows === 0) {
        this.numeroPagina = 0;
      } else {
        this.numeroPagina = event.first / event.rows;
      }
    }
    if(event.sortField && event.sortOrder) {
      this.definirOrdenacao(event.sortField, event.sortOrder);
    }
    this.listarCaixas();
  }


  abrirDialogCaixa() {
    this.dataAtual = new Date();
    this.dataSelecionadaNovoCaixa = undefined;
    this.exibirDialogAbrirCaixa = true;
  }

  abrirCaixa() {
    this.loadingSpinnerAbrirCaixa = true;
    const novoCaixa: Caixa = {
      empresaId: this.getEmpresa().id,
      dataCaixa: this.dataSelecionadaNovoCaixa,
      usuario: this.getUsuarioLogadoSistema()
    };
    this.caixaService.abrirCaixaGerenciar(novoCaixa).subscribe({
      next: (data: Caixa) => {
        this.exibirMensagemSucesso();
        this.loadingSpinnerAbrirCaixa = false;
        this.exibirDialogAbrirCaixa = false;
        this.listarCaixas();
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
        this.loadingSpinnerAbrirCaixa = false;
        this.exibirDialogAbrirCaixa = false;
      }
    })
  }

  definirOrdenacao(sortField?: string, sortOrder?: number) {
    const campoDeOrdenacao = sortField ? sortField : 'dataCaixa';
    const direcaoOrdenacao = sortOrder === -1 ? 'DESC' : 'ASC';
    this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
  }

  buscar() {
    if(this.dataCaixa) {
      this.listarCaixas();
    }
  }

  limpar(table: Table) {
    this.dataCaixa = undefined;
    this.statusSelecionado = 'TODOS';
    this.ordenacao = 'dataCaixa,DESC';
    table.clear();
  }

}
